import * as actions from "./types";

export function clearUser() {
  return {
    type: actions.CLEAR_USER
  };
}

export function getUserStart() {
  return {
    type: actions.GET_USER_START
  };
}
export function getUserSuccess(user) {
  return {
    type: actions.GET_USER_SUCCESS,
    payload: user
  };
}
export function getUserFail(error) {
  return {
    type: actions.GET_USER_FAIL,
    payload: error
  };
}

export function editUserStart() {
  return {
    type: actions.EDIT_USER_START
  };
}
export function editUserSuccess(user) {
  return {
    type: actions.EDIT_USER_SUCCESS,
    payload: user
  };
}
export function editUserFail(error) {
  return {
    type: actions.EDIT_USER_FAIL,
    payload: error
  };
}

export function removeUserStart() {
  return {
    type: actions.REMOVE_USER_START
  };
}

export function removeUserSuccess() {
  return {
    type: actions.REMOVE_USER_SUCCESS
  };
}

export function removeUserFail(error) {
  return {
    type: actions.REMOVE_USER_FAIL,
    payload: error
  };
}

export function getUserGroupsStart() {
  return {
    type: actions.GET_USER_GROUPS_START
  };
}

export function getUserGroupsSuccess(groups) {
  return {
    type: actions.GET_USER_GROUPS_SUCCESS,
    payload: groups
  };
}

export function getUserGroupsFail(error) {
  return {
    type: actions.GET_USER_GROUPS_FAIL,
    payload: error
  };
}

export function getUserGroupStart() {
  return {
    type: actions.GET_USER_GROUP_START
  };
}

export function getUserGroupSuccess(group) {
  return {
    type: actions.GET_USER_GROUP_SUCCESS,
    payload: group
  };
}

export function getUserGroupFail(error) {
  return {
    type: actions.GET_USER_GROUP_FAIL,
    payload: error
  };
}

export function editUserGroupStart() {
  return {
    type: actions.EDIT_USER_GROUP_START
  };
}

export function editUserGroupSuccess(group) {
  return {
    type: actions.EDIT_USER_GROUP_SUCCESS,
    payload: group
  };
}

export function editUserGroupFail(error) {
  return {
    type: actions.EDIT_USER_GROUP_FAIL,
    payload: error
  };
}

export function getUsersStart() {
  return {
    type: actions.GET_USERS_START
  };
}

export function getUsersSuccess(users) {
  return {
    type: actions.GET_USERS_SUCCESS,
    payload: users
  };
}

export function getUsersFail(error) {
  return {
    type: actions.GET_USERS_SUCCESS,
    payload: error
  };
}

export function createUserStart() {
  return {
    type: actions.CREATE_USER_START
  };
}
export function createUserSuccess(user) {
  return {
    type: actions.CREATE_USER_SUCCESS,
    payload: user
  };
}
export function createUserFail(error) {
  return {
    type: actions.CREATE_USER_FAIL,
    payload: error
  };
}



// WEBPACK FOOTER //
// ./src/system/store/Users/actions.js